<template>
  <div class="stay-search-menu">
    <div class="stay-search-menu__inner">
      <div class="stay-search-menu__sidebar --pc">
        <!-- 国内宿泊のサイドメニュー（PC） -->
        <DomesticSidebar
          v-if="!isPublicStay"
          :isError="error.keywordError !== ''"
          :isShowSupplementaryCoupon="isShowSupplementaryCoupon"
          :isShowCafeteriaPoint="isShowCafeteriaPoint"
          @inputed="(params, dest) => onSearchFromDomesticSidebar(params, dest)"
        />
        <!-- 公共の宿のサイドメニュー（PC） -->
        <PublicSidebar
          v-if="isPublicStay"
          :isError="error.keywordError !== ''"
          @inputed="onSearchFromDomesticSidebar"
        />
        <!-- <HorizontalFilterMenu
          v-if="!$utils.isSmartPhone()"
          :filterForm="filterForm"
          :filterFormOptions="filterFormOptions"
          :totalItems="totalItemsNative"
          :error="error"
          :isShowSupplementaryCoupon="isShowSupplementaryCoupon"
          @switchCategory="switchCategory()"
          @search="onSearch(true)"
          @search-native="onSearchNative"
        /> -->
      </div>

      <!-- 検索結果一覧 -->
      <div class="stay-search-menu__body">
        <!-- 「xxx」の「ホテル/旅館」一覧 -->
        <TitleForSearchResultList :title="createdTitle" />

        <!-- エラーメッセージ（PC） -->
        <ErrorMessageForIncorrectInput
          :errorMessage="error.keywordError"
          deviceType="pc"
        />

        <!-- 現在の検索条件を表示（PC） -->
        <BlockSelectedData
          v-if="windowWidth > 639"
          deviceType="pc"
          :isPublicStay="isPublicStay"
          :destinationLabel="createdDestinationLabel"
          :keywordLabel="createdKeywordLabel"
          :stayPeriodLabel="createdStayPeriodLabel"
          :stayNightsLabel="createdStayNightsLabel"
          :peoplesLabel="createdPeoplesLabel"
          :roomsLabel="createdRoomsLabel"
          :priceLabel="createdPriceLabel"
          :specialConditionsLabel="createdSpecialConditionsLabel"
        />
        
        <!-- サイドメニュー（SP） -->
        <div class="stay-search-menu__sidebar --sp">
          <!-- 現在の選択条件を表示 -->
          <div
            class="stay-search-menu__sidebar__inner"
            :class="{ 'is-visible': !isSidebarVisible }"
          >
            <div>
              <!-- 現在の検索条件を表示（SP） -->
              <BlockSelectedData
                v-if="windowWidth < 640"
                deviceType="sp"
                :isPublicStay="isPublicStay"
                :destinationLabel="createdDestinationLabel"
                :keywordLabel="createdKeywordLabel"
                :stayPeriodLabel="createdStayPeriodLabel"
                :stayNightsLabel="createdStayNightsLabel"
                :peoplesLabel="createdPeoplesLabel"
                :roomsLabel="createdRoomsLabel"
                :priceLabel="createdPriceLabel"
              />
            </div>
          </div>
          <!-- 条件設定画面 -->
          <div
            class="stay-search-menu__sidebar__inner"
            :class="{ 'is-visible': isSidebarVisible }"
          >
            <div>
              <!-- 国内宿泊のサイドメニュー（SP） -->
              <DomesticSidebarSP
                v-if="!isPublicStay"
                :errorMessage="error.keywordError"
                @inputed="(params, dest) => onSearchFromDomesticSidebar(params, dest)"
              />
              <!-- 公共の宿のサイドメニュー（SP） -->
              <PublicSidebarSP
                v-if="isPublicStay"
                :errorMessage="error.keywordError"
                @inputed="onSearchFromDomesticSidebar"
              />
            </div>
          </div>
          <!-- 表示切替ボタン -->
          <button
            class="stay-search-menu__button --toggle"
            @click="switchSidebarVisible"
          >
            <span v-if="isSidebarVisible">閉じる</span>
            <span v-else>再検索する</span>
            <AppIconArrow :isFocus="isSidebarVisible" />
          </button>
        </div>

        <!-- こだわり条件（SP） -->
        <!-- TODO: コンポーネントに切り出すこと -->
        <div
          v-if="!isPublicStay"
          class="search-condition hidden sm:block"
        >
          <div class="flex items-center mt-4">
            <a-button
              class="search-condition-button flex items-center"
              @click="isShowSpecialConditionsModal = true"
            >
              <icon
                class="content_button_icon"
                name="search_condition"
              />こだわり条件
            </a-button>
            <p
              class="search-condition-text"
              v-text="createdSpecialConditionsLabel || '指定なし'"
            ></p>
          </div>
        </div>

        <!-- こだわり条件のタブリスト（PCのみ） -->
        <!-- <div class="menu-tags my-4" v-if="false">
          <ListMenuTag
            v-if="!isMobileSize"
            :tagList="filterFormTags"
            @clicked-close="(category, value) => onRemoveTags(category, value)"
          />
        </div> -->

        <!-- ページネーションやソート等 -->
        <section
          v-if="yadosTotal"
          class="stay-search-menu__options"
        >
          <!-- アイコンの見方 -->
          <div class="stay-search-menu__icon-guide">
            <a
              href="https://bs.benefit-one.inc/otherPage?other_id=help_icon"
              class="stay-search-menu__icon-guide__link"
            >
              <img
                class="stay-search-menu__icon-guide__image"
                src="@/assets/icon/icon_info_gray.svg"
                alt=""
              />
              <span>各種アイコンについて</span>
            </a>
          </div>

          <!-- ページネーション -->
          <div class="stay-search-menu__pagination">
            <div class="stay-search-menu__pagination__label">
              <span class="is-strong">{{ this.yadosTotal }}</span>
              <span>{{ paginationText }}</span>
            </div>
            <Pagination
              class="stay-search-menu__pagination__pager"
              :page="pagination.page"
              :totalRecord="yadosTotal"
              @onChange="paging"
            />
          </div>

          <!-- おすすめ順・安い順・高い順の並び替え -->
          <AppSelectArray
            v-if="!isPublicStay"
            :value="filterForm.orderBy"
            :list="sortOptions"
            class="stay-search-menu__sort"
            @changed="changeSort"
          />
        </section>

        <!-- TODO: isPageOrMoreが存在しない -->
        <!-- <div v-if="isPageOrMore">
          <section class="p-0">
            <p class="text-note" style="color: #da291c">
              検索結果が多いため、すべての検索結果を表示できませんでした。条件を追加して絞り込んでください。
            </p>
          </section>
        </div> -->

        <div v-if="isLoadingOpensearch" class="content-wrapper py-20">
          <LoadingContent/>
        </div>

        <template v-if="yadosTotal">
          <!-- <div v-if="!isLoadingOpensearch"> -->
            <!-- TODO: 恒久対応後 v-if="!isPublicStay" を削除 -->
            <template v-if="!isPublicStay">
              <SearchMenuItem
                :menu="item"
                :isPublicStay="isPublicStay"
                :filterForm="filterForm"
                :userCafeSubscriptionId="userCafeSubscriptionId"
                :userSubsidyList="userSubsidyList"
                :zaikoList="zaikoList"
                :stompClient="stompClient"
                v-for="(item, index) in menuListSearch"
                :key="`menu-item-${index}`"
                :plansBenepoReturnInfo="plansBenepoReturnInfo"
                @onToggleFav="updateFavourite"
              />
            </template>
            <!------------------------------------------------->
            <template v-if="isPublicStay">
              <!-- TODO: 恒久対応後削除 -->
              <SearchMenuItemPublic
                :menu="item"
                :isPublicStay="isPublicStay"
                :filterForm="filterForm"
                :userCafeSubscriptionId="userCafeSubscriptionId"
                :userSubsidyList="userSubsidyList"
                v-for="(item, index) in menuListSearch"
                :key="`menu-item-${index}`"
                @onToggleFav="updateFavourite"
              />
            </template>
            <!------------------------->
          <!-- </div> -->
        </template>
        <div v-else>
          <div v-if="!isLoadingOpensearch" class="py-40">
          <a-list :data-source="[]" />
            <div class="text-center">
              <span>
                <div v-if="!isLoadingOpensearch">
                  指定された条件に該当する検索結果はありませんでした。<br />
                  {{ emptyDataMessage }}
                </div>
              </span>
            </div>
          </div>
        </div>

        <section v-if="yadosTotal" class="p-0 mb-4">
          <div class="pagination sm:flex-col-reverse">
            <div class="flex items-center">
              <strong>{{ yadosTotal }}</strong>
              {{ paginationText }}
            </div>
            <Pagination
              class="flex justify-center pt-2 pb-2"
              :page="pagination.page"
              :totalRecord="yadosTotal"
              @onChange="paging"
            />
          </div>
        </section>

        <!-- ご注意 -->
        <BlockCautionText />
      </div>

      <!-- お気に入りを促すポップアップ 必要？ -->
      <InstructionLogin1 :visible="showPopup" @cancel="showPopup = false" />
    </div>

    <!-- こだわり条件モーダル（SP） -->
    <ModalSpecialConditions
      :isVisible="isShowSpecialConditionsModal"
      :facility="facility"
      :roomType="roomType"
      :mealCondition="mealCondition"
      :roomCondition="roomCondition"
      :serviceEquip="serviceEquip"
      :usageMethod="usageMethod"
      :planByCompany="planByCompany"
      @inputed="setSpecialConditionsFromSPModal"
      @closed="onSearchFromModalSpecialConditionsSP()"
    />
    <!-- 旧こだわり条件モーダル（SP） -->
    <!-- <ModalSpecifyFilter
      title="こだわり条件を指定"
      :isModalVisible="isShowSpecialConditionsModal"
      :filterForm="filterForm"
      :filterFormOptions="filterFormOptions"
      :totalItems="totalItemsNative"
      @clicked-close="isShowSpecialConditionsModal = false"
      @clicked-dicision="onSearch(); isShowSpecialConditionsModal = false"
    /> -->
  </div>
</template>

<script>
// import {
//   HorizontalFilterMenu,
//   Breadcrumb
//   // SectionContentTitle,
//   // CarouselEvents
// } from '@/components/compound'
import func_utils from '@/mixins/func_utils'
import { Pagination, Tag } from '@/components/primitive'
import { get, uniq, cloneDeep, forEach, isEmpty, filter, uniqBy, isEqual } from 'lodash'
import moment from 'moment'
// import Datepicker from "vuejs-datepicker";
// import { ja } from 'vuejs-datepicker/dist/locale';
// import StaySearchChildrenPicker from "@/components/StaySearchChildrenPicker.vue";
import searchMock from '@/views/search/BS_SCH_03_001/searchMock'
// import areaMock from '@/views/search/BS_SCH_03_001/areaMock'
import { BREADCRUMBS } from '@/store/modules/app/actions'
// import PeopleFilter from '../components/PeopleFilter'
// import SpecifyFilter from '../components/SpecifyFilter'
import priceTable from "@/components/filterPropertiesMock.js";
import SearchMenuItem from './components/SearchMenuItem'
import SearchMenuItemPublic from './components/SearchMenuItem/index-public'
import { mappingKeyRoomType } from '@/utils/page/menuSearch'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { createSetCookie } from '@/utils/cookie'

import PrefecturesList from './components/prefecturesList.json'
import specialConditionsList from './components/specialConditionsList.json'
import { filterRakutenFromConditions } from '@/utils/func_utils'
import specialConditionsListAddSupplementary from './components/specialConditionsListAddSupplementary.json'
import DomesticSidebar from './components/DomesticSidebar'
import DomesticSidebarSP from './components/DomesticSidebarSP'
import PublicSidebar from './components/PublicSidebar'
import PublicSidebarSP from './components/PublicSidebarSP'
import TitleForSearchResultList from './components/TitleForSearchResultList/'
import ModalSpecialConditions from './components/ModalSpecialConditions'
import ErrorMessageForIncorrectInput from './components/ErrorMessageForIncorrectInput/'
// import ListMenuTag from './components/ListMenuTag/'
import BlockCautionText from './components/BlockCautionText/'
import BlockSelectedData from './components/BlockSelectedData/'
import AppIconArrow from '@/components/elements/AppIconArrow'
import AppSelectArray from '@/components/elements/AppSelectArray'
import Cookies from "js-cookie";
export default {
  mixins: [func_utils],
  components: {
    Pagination,
    // Rating,
    // HorizontalFilterMenu,
    // SectionContentTitle,
    // CarouselEvents,
    // Tag,
    // PeopleFilter,
    // SpecifyFilter,
    // Breadcrumb,
    SearchMenuItem,
    SearchMenuItemPublic,

    /* BSFRONT_INSOURCING-26 ここから */
    // TODO: 2024/7/10納品優先でベタ書き -> コンポーネントに切り出すこと
    // Datepicker,
    // TODO: ↓ ここから持ってきました
    // @see https://github.com/BenefitOne/bo-bsff-frontend-top/blob/feature/69359_cassette_design/src/components/StaySearchChildrenPicker.vue
    DomesticSidebar,
    DomesticSidebarSP,
    PublicSidebar,
    PublicSidebarSP,
    // StaySearchChildrenPicker,
    // SelectModal,
    // ModalSpecifyFilter,
    ModalSpecialConditions,
    ErrorMessageForIncorrectInput,
    TitleForSearchResultList,
    // ListMenuTag,
    BlockCautionText,
    BlockSelectedData,
    AppIconArrow,
    AppSelectArray,
    /* BSFRONT_INSOURCING-26 ここまで */
  },  
  props: {
    isShowSupplementaryCoupon: {
      type: Boolean,
      default: false
    }, // 補助クーポンが使えるが出現するフラグ
    isShowCafeteriaPoint: {
      type: Boolean,
      default: false
    }, // カフェテリアポイントが使えるが出現するフラグ
  },
  data() {
    return {
      searchDest: [],
      rooms: "1",
      adult: 2,
      child: 0,
      people: 1,

      childDetails: {},
      /* BSFRONT_INSOURCING-26 ここまで */

      filterCategories: [
        {
          label: '国内宿泊',
          value: 'stay'
        },
        // CRM汎用独自対応↓↓↓
        // {
        //   label: '公共の宿',
        //   value: 'publicStay'
        // }
        // CRM汎用独自対応↑↑↑
      ],
      docTitle: '',
      menuListSearch: [],
      userCafeSubscriptionId: [],
      userSubsidyList: [],
      filterForm: {
        numPeople: 1,
        adultHeadCnt: 1,
        feeLower: 0,
        feeUpper: 0,
        facility: [],
        roomType: [],
        mealCondition: [],
        roomCondition: [],
        serviceEquip: [],
        usageMethod: [],
        planByCompany: [],
        checkInDate: '',
        areaLrgClassCd: undefined,
        areaMidClassCd: undefined,
        areaSmlClassCd: undefined,
        areaDtlClassCd: undefined,
        keyword: '',
        orderBy: '安い順',
        stayNights: 1,
        orderBy: 'おすすめ順',
        category: 'stay',
        exUpperGradesHeadCnt: 0,        // 高学年
        exLowerGradesHeadCnt: 0,        // 低学年
        youjiAHeadCnt: 0,               // 食事・布団付き
        youjiBHeadCnt: 0,               // 食事のみ
        youjiCHeadCnt: 0,               // 布団のみ
        youjiDHeadCnt: 0,               // 食事・布団不要
        roomCnt: 1,
      },
      excludeKeys: [],
      initFilterForm: {},
      flagChange: false,
      filterFormTags: [],
      filterFormOptions: {},

      yadosTotal: 0,
      totalItemsNative: 0,

      showPopup: false,
      breadcrumbs: [],
      pagination: {
        page: 1
      },
      sortOptions: [
        {
          text: 'おすすめ順',
          label: 'おすすめ順',
          value: 'PROPOSE',
          disabled: false
        },
        {
          text: '人気順',
          label: '人気順',
          value: 'POPULAR',
          disabled: false
        },
        {
          text: '安い順',
          label: '安い順',
          value: 'LOWEST_PRICE',
          disabled: false
        },
        {
          text: '高い順',
          label: '高い順',
          value: 'HIGHEST_PRICE',
          disabled: false
        }
      ],
      dataImg: [
        { imgSrc: require('@/assets/images/banner1.png') },
        { imgSrc: require('@/assets/images/banner2.png') },
        { imgSrc: require('@/assets/images/banner3.png') },
        { imgSrc: require('@/assets/images/banner1.png') },
        { imgSrc: require('@/assets/images/banner3.png') },
        { imgSrc: require('@/assets/images/banner2.png') }
      ],
      // isShowCategoryPopup: false, // 240829時点未使用
      isShowPeopleFilter: false,
      isShowSpecialConditionsModal: false,
      // checkInDateStock: '', // 240829時点未使用
      // categorySearch: null, // 240829時点未使用
      areaData: {},
      queryParams: null,
      error:{
        keywordError: ''
      },
      isLoadingOpensearch: false,
      // lrgCategoryList: [], // 240829時点未使用
      midCategoryList: [],
      smlCategoryList: [],
      categoryList: [],
      stompClient: null,
      zaikoList: [],
      socket: null,

      
      selectMid: [],                     // 上記IDを基に、PrefecturesList.jsonからフィルタリングした都道府県情報
      selectSml: [],                     // 〃 市区町村情報
      selectDtl: [],                     // 〃 エリア情報
      facility: [],                      // 施設タイプ（データ加工用）
      roomType: [],                      // 部屋タイプ（データ加工用）
      mealCondition: [],                 // 食事条件（データ加工用）
      roomCondition: [],                 // 部屋のこだわり（データ加工用）
      serviceEquip: [],                  // 設備・サービス（データ加工用）
      usageMethod: [],                   // 利用方法（データ加工用）
      planByCompany: [],                 // 提供会社（データ加工用）
      createdTitle: '',                  //「xxx」の「ホテル/旅館」一覧
      createdDestinationLabel: '',       //「都道府県 / 市区町村 / エリア」
      createdKeywordLabel: '',           // 検索されたキーワード
      createdStayPeriodLabel: '',        // 「yyyy/mm/dd ～ yyyy/mm/dd」の文字列
      createdStayNightsLabel: '',        // 「x泊」の文字列
      createdPeoplesLabel: '',           // 「大人x人 + 子どもx人」の文字列
      createdRoomsLabel: '',             // 「x部屋」の文字列
      createdPriceLabel: '',             // 「x円 ～ x円」の文字列
      createdSpecialConditionsLabel: '', // こだわり条件を「/」で連結させたの文字列
      displayPeopleAndRoomLength: '',    // 表示用の人数ラベル
      isSidebarVisible: false,           // DomesticSidebarSPが表示されているか
      isModalVisible: false,             // ModalSpecialConditionsが表示されているか
      windowWidth: 0,                    // 画面幅
      plansBenepoReturnInfo: [],
    }
  },
  async created() {
    // searchMock.dataはこだわり条件のobject[]
    this.filterFormOptions = cloneDeep(searchMock.data)

    const query = this.$route.query

    // 240829時点未使用
    // this.categorySearch = query.category
    
    // クエリに保存されているページ情報取得
    const page = Number(query.page)
    if (page){
      this.pagination.page = page;
    }

    // プラン一覧のページ情報削除
    if (query.planPage){
      delete query.planPage
    }

    this.setFilterForm(query)
    this.checkInDateStock = this.filterForm.checkInDate

    this.getMenuList(true)

    // 240829時点未使用
    // DP検索対応 start
    // DP検索用のカテゴリセット
    // this.lrgCategoryList = [
    //   {
    //     "flag": false,
    //     "catLrgClassCd": "",
    //     "level1": "トラベル",
    //     "level2": [],
    //     "catClassCd": "101",
    //     "catMidClassCd": ""
    //   }
    //  ];

    // 240829時点未使用
    // this.midCategoryList = [
    //   {
    //     "flag": false,"catLrgClassCd": "101","catClassCd": "205","name": "パッケージツアー・旅行代理店",
    //     "level3": [
    //       {"name": "パッケージツアー","catClassCd": "301","catMidClassCd": "205","catLrgClassCd": "101"},
    //       {"name": "旅行代理店","catClassCd": "302","catMidClassCd": "205","catLrgClassCd": "101"}
    //     ],
    //   },
    //   {
    //     "flag": false,"catLrgClassCd": "101","catClassCd": "206","name": "航空券・交通",
    //     "level3": [
    //       {"catClassCd": "301","catMidClassCd": "206","catLrgClassCd": "101","name": "航空券"},
    //       {"catClassCd": "302","catMidClassCd": "206","catLrgClassCd": "101","name": "フェリー・クルーズ"},
    //       {"catClassCd": "303","catMidClassCd": "206","catLrgClassCd": "101","name": "バス･タクシー"},
    //       {"catClassCd": "304","catMidClassCd": "206","catLrgClassCd": "101","name": "その他航空券・交通"}
    //     ],
    //   },
    //   {
    //     "flag": true,"catLrgClassCd": "101","catClassCd": "207","name": "その他旅行関連",
    //     "level3": [
    //       {"catClassCd": "301","catMidClassCd": "207","catLrgClassCd": "101","name": "その他旅行関連"}
    //     ],
    //   },
    //   {
    //     "flag": true,"catLrgClassCd": "101","catClassCd": "201","name": "国内の宿",
    //     "level3": [
    //       {"catClassCd": "311","catMidClassCd": "201","catLrgClassCd": "101","name": "予約サイト"}
    //   ]
    //   },
    //   {
    //     "flag": true,"catLrgClassCd": "101","catClassCd": "204","name": "海外旅行",
    //     "level3": [
    //       {"catClassCd": "301","catMidClassCd": "204","catLrgClassCd": "101","name": "海外旅行"}
    //     ],
    //   }
    // ]

    // 240829時点未使用
    // アコーディオンで最初は小カテゴリは非表示にするため、flagをfalseに設定
    // this.smlCategoryList = [
    //   {"flag": false,"catClassCd": "301","catMidClassCd": "205","catLrgClassCd": "101","name": "パッケージツアー"},
    //   {"flag": false,"catClassCd": "302","catMidClassCd": "205","catLrgClassCd": "101","name": "旅行代理店"},
    //   {"flag": false,"catClassCd": "301","catMidClassCd": "206","catLrgClassCd": "101","name": "航空券"},
    //   {"flag": false,"catClassCd": "302","catMidClassCd": "206","catLrgClassCd": "101","name": "フェリー・クルーズ"},
    //   {"flag": false,"catClassCd": "303","catMidClassCd": "206","catLrgClassCd": "101","name": "バス･タクシー"},
    //   {"flag": false,"catClassCd": "304","catMidClassCd": "206","catLrgClassCd": "101","name": "その他航空券・交通"},
    //   {"flag": false,"catClassCd": "301","catMidClassCd": "207","catLrgClassCd": "101","name": "その他旅行関連"},
    //   {"flag": false,"catClassCd": "311","catMidClassCd": "201","catLrgClassCd": "101","name": "国内宿泊予約サイト"},
    //   {"flag": false,"catClassCd": "301","catMidClassCd": "204","catLrgClassCd": "101","name": "海外宿泊予約サイト"}
    // ];

    // this.catListGen;
    // DP検索対応 end
  },

  beforeMount() {
    this.breadcrumbs = cloneDeep(get(this.$route, 'meta.breadcrumbs', []))
  },

  mounted() {
    // 画面幅の取得
    this.getWindowWidth()

    // update breadcrumbs
    const mybreadcrumbs = {
      path: '/search/menu',
      title: this.isPublicStay ? '公共の宿' : '国内宿泊'
    }
    this.breadcrumbs.push(mybreadcrumbs)
    this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)

    this.initSpecialConditions()
    this.createLabelForTitle()
    this.createLabelForKeyword()
    this.createLabelForStayPeriod()
    this.createLabelForPeopleAndRooms()
    this.createLabelForPrice()
    this.createLabelForSpecialConditions()
  },

  updated() {
    /* BSFRONT_INSOURCING-26 ここから */
    // TODO: 画面表示時に「泊」の助数詞が出ない。文字列を流し込んでるせいだと思われ。ロジックなおす時間ないので逃げます
    this.filterForm.stayNights = Number(this.filterForm.stayNights || this.$route.query.stayNights) || 1;
    /* BSFRONT_INSOURCING-26 ここまで */
  },
  watch: {
    '$route.query'(query) {
      this.setFilterForm(query)
      this.initSpecialConditions()
      this.createLabelForTitle()
      this.createLabelForKeyword()
      this.createLabelForStayPeriod()
      this.createLabelForPeopleAndRooms()
      this.createLabelForPrice()
      this.createLabelForSpecialConditions()
    },
    isShowCafeteriaPoint() {
      this.initSpecialConditions()
    },
    isShowSupplementaryCoupon() {
      this.initSpecialConditions()
    },
    isPublicStay() {
      if (this.isPublicStay) this.flagChange = true
      else this.flagChange = false
    },
    // numPeople(val) {
    //   this.filterForm.numPeople = val
    // },
    flagChange() {
      this.yadosTotal = 0;
      this.totalItemsNative = 0;
      this.menuListSearch = [];
      this.userCafeSubscriptionId = null;
      this.userSubsidyList = [];
    },
  },

  computed: {
    /**
     * モバイル端末の判定
     */
    isMobileSize() {
      return this.$utils.isSmartPhone() || this.windowWidth < 640
    },
    getHeadLineWord() {
      return this.docTitle.replace(/\s*\｜\s*/, '|').split('|')[0]
    },
    /* BSFRONT_INSOURCING-26 ここから */
    // TODO: 2024/7/10納品優先でベタ書き -> コンポーネントに切り出すこと
    areaNameFromDocTitle() {
      // MEMO: _.getの第三引数はundefinedのときのみ有効、nullは対応していない
      return get(this.getHeadLineWord.match(/^「(.+?)」/), '[1]') || '';
    },
    // @see: https://github.com/BenefitOne/bo-bsff-frontend-top/blob/feature/69359_cassette_design_add_ph20/src/components/StaySearch.vue#L656-L661
    getpriceTableFeeLower() {
      return priceTable.data.feeLower;
    },
    getpriceTableFeeUpper() {
      return priceTable.data.feeUpper;
    },
    /* BSFRONT_INSOURCING-26 ここまで */
    emptyDataMessage() {
      const defaultFilterQuery = {
        adultHeadCnt: '2',
        category: 'stay',
        numPeople: '2',
        roomCnt: '1',
        rooms: '1',
        stayNights: '1'
      }
      const query = this.$route.query
      if (query.keyword) {
        let compareQuery = cloneDeep(query)
        delete compareQuery.keyword
        if (isEqual(compareQuery, defaultFilterQuery))
          return 'メニュー名・メニューNoの確認をしていただくか、再度検索してください。'
      }
      return '条件を変更して再度検索してください。'
    },
    /**
     * filterForm.numPeopleを算出する
     * 51861対応: 幼児食事のみ or 幼児食事・布団無を選択した際は定員人数としてカウントしない
     */
    numPeople() {
      return (
        (parseInt(this.filterForm.adultHeadCnt) || 0) +
        (parseInt(this.filterForm.exUpperGradesHeadCnt) || 0) +
        (parseInt(this.filterForm.exLowerGradesHeadCnt) || 0) +
        (parseInt(this.filterForm.youjiAHeadCnt) || 0) +
        // (parseInt(this.filterForm.youjiBHeadCnt) || 0) +
        (parseInt(this.filterForm.youjiCHeadCnt) || 0)
        // (parseInt(this.filterForm.youjiDHeadCnt) || 0)
      )
    },
    // 240829時点未使用
    // currentDay() {
    //   return this.checkInDateStock
    //     ? moment(this.checkInDateStock).format('YYYY/MM/DD')
    //     : moment().format('YYYY/MM/DD')
    // },
    /**
     * ページネーション用
     */
    paginationText() {
      const firstItem = this.pagination.page * 10

      let lastItem = firstItem
      if (this.yadosTotal < firstItem) {
        lastItem = this.yadosTotal
      }
      return `件中 ${firstItem - 9}～${lastItem}件表示`
    },
    /**
     * 「公共の宿」であるかを判定
     */
    isPublicStay() {
      return this.filterForm.category === 'publicStay'
    },
    /* BSFRONT_INSOURCING-26 ここまで */
    // DP検索で使用する処理追加 start
    // catListGen() {
    //   console.log('this.gen')
    //   this.categoryList = this.lrgCategoryList;
    //   const selected = '101';
    //   if (selected > 0) {
    //     let middles = this.midCategoryList.filter(
    //       (item) => item.catLrgClassCd === selected.toString()
    //     );
    //     middles.forEach((mid) => {
    //       let smalls = this.smlCategoryList.filter(
    //         (item) =>
    //           item.catMidClassCd === mid.catClassCd.toString() &&
    //           item.catLrgClassCd === selected.toString()
    //       );
    //       mid.level3 = smalls;
    //     });
    //     const selectedItem = this.categoryList.find(
    //       (item) => item.catClassCd === selected.toString()
    //     );
    //     if (selectedItem) {
    //       selectedItem.level2 = middles;
    //     }
    //     return selectedItem ? (selectedItem.flag = true) : [];
    //   } else {
    //     return false
    //   }
    // },
    // DP検索で使用する処理追加 end
    
    // 240829時点未使用
    // searchQueryExists() {
    //   return this.getHeadLineWord === "検索結果" || this.getHeadLineWord === "" ? false : true
    // },
  },
  beforeUnmount() {
    // WebSocket接続を切断する
    this.disconnectWebSocket();
  },
  /**
   * 使用されている methods 一覧
   * 
   * getWindowWidth
   * setFilterForm
   * setSpecialConditionsFromSPModal
   * onSearchFromDomesticSidebar
   * initSpecialConditions
   * createLabelForTitle
   * createLabelForKeyword
   * createLabelForStayPeriod
   * createLabelForPeopleAndRooms
   * createLabelForPrice
   * createLabelForSpecialConditions
   * disconnectWebSocket
   * subscribeToSocket
   * connect
   * async getMenuList
   * async getMenuListPublicStay
   * updateFavourite
   * updateFilterFormTags
   * onRemoveTags
   * updateQueryRouter
   * updateQueryRouterPublicStay
   * async onSearch
   * setQueryUrl
   * async paging
   * parseBodySearch
   * parseBodySearchPublicStay
   * mappingAggregation
   */
  methods: {
    cutStringByLength(str, maxLength) {
        return str.length > maxLength ? str.substring(0, maxLength) : str;
    },
    /**
     * 画面幅の取得
     */
    getWindowWidth() {      
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    },
    /**
     * filterFormに値を代入
     * @param {*} query 
     */
    setFilterForm(query) {
      const keyArray = [
        'facility',
        'roomType',
        'mealCondition',
        'roomCondition',
        'serviceEquip',
        'usageMethod',
        'planByCompany'
      ]
      const keyNumber = [
        'roomCnt',
        'rooms',
        'adultHeadCnt',
        'exLowerGradesHeadCnt',
        'exUpperGradesHeadCnt',
        'youjiAHeadCnt',
        'youjiBHeadCnt',
        'youjiCHeadCnt',
        'youjiDHeadCnt',
        'stayNights',
      ]
      const areaKeys = [
        'areaLrgClassCd',
        'areaMidClassCd',
        'areaSmlClassCd',
        'areaDtlClassCd'
      ]
      forEach(query, (value, key) => {
        if (keyArray.includes(key)) {
          this.filterForm[key] = String(value || '').split(',')
        } else if (keyNumber.includes(key)) {

          if (key === 'stayNights' && !query?.checkInDate) {
            // 日付未指定の場合は 1 泊扱い
            this.filterForm[key] = 1
          } else {
            this.filterForm[key] = parseInt(value) || 0
          }

        } else if (areaKeys.includes(key)) {
          this.filterForm[key] = value || undefined
        } else {
          this.filterForm[key] = value || ''
        }
      })

      if (!this.filterForm.orderBy) {
        this.filterForm.orderBy = 'PROPOSE'
      }
    },
    /**
     * SPのみ、こだわり条件選択モーダルをサイドメニューの外に設置している
     * その影響で機能としても切り分けられているため、こだわり条件設定も切り分けて実装
     */
    setSpecialConditionsFromSPModal(params) {
      const cafeAndSubsidy = []

      if (this.isShowCafeteriaPoint) {
        cafeAndSubsidy.push({ "id": "canUseCafeteriaPoint", "label": "カフェテリアポイントが使える" })
      }

      if (this.isShowSupplementaryCoupon) {
        cafeAndSubsidy.push({ "id": "canUseSubsidy", "label": "補助クーポンが使える" })
      }

      let list = cafeAndSubsidy.length > 0
        ? specialConditionsList.map(d => {
          if (d.id === 'usageMethod') {
            return {
              ...d,
              list: [...d.list, cafeAndSubsidy].flat()
            }
          } else {
            return { ...d }
          }
        })
        : specialConditionsList
      list = filterRakutenFromConditions(list)

      list.forEach(item => {
        const checkedItems = params[item.id].filter(d => d.checked).map(d => d.id).join()
        this.filterForm[item.id] = checkedItems
      })
      this.setFilterForm(this.filterForm)
    },
    /**
     * ModalSpecialConditionsから設定された値を使用して、ページの再読み込みを実行する
     */
    onSearchFromDomesticSidebar(params, dest) {
      if(!this.isPublicStay) {
        this.searchDest = dest;
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.setFilterForm(params)
      this.onSearch(true)
    },
    /**
     * こだわり条件モーダル（SP）から実行された場合
     */
    onSearchFromModalSpecialConditionsSP() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.onSearch()
    },
    /**
     * SP時、「再検索する⇔閉じる」のメニューの切り替えを行う
     */
    switchSidebarVisible() {
      this.isSidebarVisible = !this.isSidebarVisible
    },
    /**
     * こだわり条件の初期化（チェック状態のプロパティを追加）
     */
    initSpecialConditions() {
      const cafeAndSubsidy = []

      if (this.isShowCafeteriaPoint) {
        cafeAndSubsidy.push({ "id": "canUseCafeteriaPoint", "label": "カフェテリアポイントが使える" })
      }

      if (this.isShowSupplementaryCoupon) {
        cafeAndSubsidy.push({ "id": "canUseSubsidy", "label": "補助クーポンが使える" })
      }

      let list = cafeAndSubsidy.length > 0
        ? specialConditionsList.map(d => {
          if (d.id === 'usageMethod') {
            return {
              ...d,
              list: [...d.list, cafeAndSubsidy].flat()
            }
          } else {
            return { ...d }
          }
        })
        : specialConditionsList
      list = filterRakutenFromConditions(list)

      const query = this.$route.query
      list.forEach(item => {
        const currentCheckedItems = query[item.id] ? query[item.id].split(',') : []
        
        this[item.id] = item.list.map(data => {
          if (currentCheckedItems.includes(data.id)) {
            return { ...data, checked: true }
          }
          return { ...data, checked: false }
        })
      })
    },
    /**
     * クエリパラメータからタイトルのラベルを生成
     */
    createLabelForTitle() {
      const query = this.$route.query
      const [mid, sml, dtl] = [
        query.areaMidClassCd || undefined,
        query.areaSmlClassCd || undefined,
        query.areaDtlClassCd || undefined
      ]

      this.createdTitle = ''
      this.createdDestinationLabel = ''
      this.selectMid = []
      this.selectSml = []
      this.selectDtl = []

      // 表示用にテキストを加工する関数
      const _createTitle = str => {
        document.title = `「${str}」の「ホテル/旅館」一覧｜割引・特別優待ならベネフィットステーション`
        return `「${str}」の「ホテル/旅館」一覧`
      }

      if (mid === undefined && sml === undefined && (dtl === undefined || dtl.length < 1)) {
        // 都道府県・市区町村・エリア情報がなければキーワードを設定して終了
        const hasKeyword = query.keyword
        if (hasKeyword) {
          this.createdTitle = _createTitle(query.keyword)
        }
        return
      }

      if (mid !== undefined) this.selectMid = PrefecturesList.filter(d => d.id === mid)
      if (sml !== undefined) {
        if (sml.includes(',')) {
          const smls = sml.split(',')
          this.selectSml = this.selectMid[0].target.filter(d => smls.includes(d.id))
        } else {
          this.selectSml = this.selectMid[0].target.filter(d => d.id === sml)
        }
      }
      if (dtl !== undefined) {
        // エリア情報がある場合
        if (Object.keys(this.selectSml[0]).includes('target')) {
          // エリアが複数の場合
          if (dtl.includes(',')) {
            const areaList = dtl.split(',')
            this.selectSml[0].target.forEach(item => {
              if (areaList.includes(item.id)) {
                this.selectDtl.push(item)
              }
            })
          }
          // エリアが単一の場合
          else {
            this.selectSml[0].target.forEach(item => {
              if (dtl === item.id) {
                this.selectDtl.push(item)
              }
            })
          }
        }
        // エリア情報が無い場合
        // else {}
      }

      // 都道府県・市区町村・エリアの文字列を格納する配列
      const _createLabel = []
      // 市区町村が複数ある場合もあるので、それを格納する配列
      const _smallLabel = []
      // エリアが複数ある場合もあるので、それを格納する配列
      const _detailLabel = []

      // 都道府県ラベルを追加
      if (this.selectMid.length > 0) _createLabel.push(`${this.selectMid[0].label}`)

      // 市区町村があり、エリアが選択されている場合
      if (this.selectSml.length > 0 && this.selectDtl.length > 0) {
        const selectSmlLength = this.selectSml.length
        if (selectSmlLength > 1) {
          this.selectSml = this.selectSml.filter((_, i) => i !== 0)
        }

        this.selectSml.forEach(item => {
          _smallLabel.push(`${item.label}`)
        })

        this.selectDtl.forEach(item => {
          _detailLabel.push(`${item.label}`)
        })

        const smallLabel = _smallLabel.join('、')
        const detailLalbel = _detailLabel.join('、')

        // エリアがあり、市区町村が複数選択されていた場合
        if (selectSmlLength > 1) {
          _createLabel.push(detailLalbel + '、' + smallLabel)
        }
        // エリアがあり、市区町村が単一選択されていた場合
        else {
          _createLabel.push(smallLabel)
          _createLabel.push(detailLalbel)
        }
      }

      // 市区町村までしか選択されていない場合
      if (this.selectSml.length > 0 && this.selectDtl.length === 0) {
        this.selectSml.forEach(item => {
          _smallLabel.push(`${item.label}`)
        })
        const smallLabel = _smallLabel.join('、')
        _createLabel.push(smallLabel)
      }

      // 都道府県・市区町村・エリアの文字列を格納した配列を「 / 」で繋げて文字列にする
      // BlockSelectDataコンポーネントで使用
      this.createdDestinationLabel = _createLabel.join(' / ')

      // document.title、BlockSelectDataコンポーネントの上部に表示されるタイトルの設定
      this.createdTitle = _createTitle(this.createdDestinationLabel)

      // エリア情報があれば、それを設定して終了
      // if (this.selectDtl.length > 0) {
      //   const dtlTitles = []
      //   this.selectDtl.forEach(item => {
      //     dtlTitles.push(item.label)
      //   })
      //   const dtlTitle = dtlTitles.join('/')
      //   this.createdTitle = _createTitle(dtlTitle)
      //   return
      // }
      // // エリアがなく、市区町村情報があれば、それを設定して終了
      // if (this.selectSml.length > 0) {
      //   this.createdTitle = _createTitle(this.selectSml[0].label)
      //   return
      // }
      // // 市区町村・エリア情報がなく、都道府県情報があれば、それを設定して終了
      // if (this.selectMid.length > 0) {
      //   this.createdTitle = _createTitle(this.selectMid[0].label)
      //   return
      // }
    },
    /**
     * クエリパラメータから検索キーワードのラベルを設定
     */
    createLabelForKeyword() {
      const query = this.$route.query
      const keyword = query?.keyword || ''
      this.createdKeywordLabel = keyword
    },
    /**
     * 宿泊開始日、宿泊日、泊数のラベルを設定
     */
    createLabelForStayPeriod() {
      this.createdStayPeriodLabel = ''
      this.createdStayNightsLabel = ''

      // queryにない場合はデフォルト設定される泊数で設定
      const stayNight = this.$route.query.stayNights || 1
      this.createdStayNightsLabel = `${stayNight}泊`

      const checkInDate = this.$route.query.checkInDate
        ? moment(this.$route.query.checkInDate)
        : moment()

      // 年月日の表示フォーマット
      const format = 'YYYY/MM/DD'

      // 宿泊期間
      const periodText = [
        checkInDate.format(format),
        checkInDate.add(stayNight, 'd').format(format),
      ].join('〜')

      // 日付指定が無い場合
      if(!this.$route.query.checkInDate){
        this.createdStayPeriodLabel = '日付指定なし'

        // 72331 宿泊施設検索-総額表示対応
        //this.createdStayNightsLabel = `${this.$route.query.stayNights}泊`
        this.createdStayNightsLabel = `1泊`

        return
      }

      // 宿泊期間があり、宿泊日数がある場合
      // （基本、宿泊日数は存在する）
      if (this.$route.query.stayNights) {
        this.createdStayPeriodLabel = periodText
        this.createdStayNightsLabel = `${this.$route.query.stayNights}泊`

      } else {
        this.createdStayPeriodLabel = periodText
      }
    },
    /**
     * 人数と部屋数のラベルを設定
     */
    createLabelForPeopleAndRooms() {
      this.createdPeoplesLabel = ''
      this.createdRoomsLabel = ''

      const query = this.$route.query
      // queryにない場合はデフォルト設定される人数で設定
      const adultCount = Number(query.adultHeadCnt || 1)
      const childCount = [
        query.exLowerGradesHeadCnt || 0,
        query.exUpperGradesHeadCnt || 0,
        query.youjiAHeadCnt || 0,
        query.youjiBHeadCnt || 0,
        query.youjiCHeadCnt || 0,
        query.youjiDHeadCnt || 0
      ].map(d => Number(d)).reduce((a, b) => a + b)

      if (childCount > 0) {
        this.createdPeoplesLabel = `大人${adultCount}人 + 子ども${childCount}人`
      } else {
        this.createdPeoplesLabel = `大人${isNaN(adultCount) ? 1 : adultCount}人`
      }

      this.createdRoomsLabel = `${query.roomCnt === undefined ? 1 : query.roomCnt}部屋`
    },
    /**
     * 下限・上限金額のラベルを設定
     */
    createLabelForPrice() {
      this.createdPriceLabel = ''
      const query = this.$route.query

      const feeLower = Number(query.feeLower) > 0 ? `${Number(query.feeLower).toLocaleString()}円` : '下限なし'
      const feeUpper = Number(query.feeUpper) > 0 ? `${Number(query.feeUpper).toLocaleString()}円` : '上限なし'

      this.createdPriceLabel = `${feeLower} ～ ${feeUpper}`
    },
    /**
     * こだわり条件のラベルを設定
     */
    createLabelForSpecialConditions() {
      this.createdSpecialConditionsLabel = ''

      const keyArray = [
        'facility',
        'roomType',
        'mealCondition',
        'roomCondition',
        'serviceEquip',
        'usageMethod',
        'planByCompany'
      ]

      let conditions = []

      const companyCd = sessionStorage.getItem('companyCd') || ''
      const disableRakuten = companyCd !== '' &&
        process.env.VUE_APP_DISABLE_RAKUTEN_TRAVEL
          ?.split(',')
          .includes(companyCd)
      keyArray.forEach((key) => {
        this.filterForm[key].forEach((filterKeyword) => {
          if (filterKeyword === 'isRakuten' && disableRakuten) {
            return
          }
          const stuff = get(this.filterFormOptions[key].filter((options) => {
            return options.value === filterKeyword
          }), '[0].displayName', '')
          if (stuff !== '') conditions.push(stuff)
        })
      })
      
      this.createdSpecialConditionsLabel = conditions.join(' / ')
    },
    /**
     * 並び替えが変更されたら
     */
    changeSort(value) {
      this.filterForm.orderBy = value
      this.onSearch(true)
    },
    disconnectWebSocket() {
      // WebSocket接続を保持する変数
      if (this.socket) {
        this.socket.close();
        // console.log('WebSocket connection closed');
      }
    },
    subscribeToSocket(responseMenuList) {
          // メッセージを送信する
          //stompClient.send("/app/sendMessage", {}, JSON.stringify(responseMenuList));
          var socketPrm = {};
          socketPrm['checkInDay'] = responseMenuList['body']['checkInDate'];
          socketPrm['checkOutDay'] = responseMenuList['body']['checkOutDate'];
          socketPrm['roomCnt'] = responseMenuList['body']['roomCnt'];
          socketPrm['adultHeadCnt'] = responseMenuList['body']['adultHeadCnt'];
          socketPrm['exUpperGradesHeadCnt'] = responseMenuList['body']['exUpperGradesHeadCnt'];
          socketPrm['exLowerGradesHeadCnt'] = responseMenuList['body']['exLowerGradesHeadCnt'];
          socketPrm['youjiAHeadCnt'] = responseMenuList['body']['youjiAHeadCnt'];
          socketPrm['youjiBHeadCnt'] = responseMenuList['body']['youjiBHeadCnt'];
          socketPrm['youjiCHeadCnt'] = responseMenuList['body']['youjiCHeadCnt'];
          socketPrm['youjiDHeadCnt'] = responseMenuList['body']['youjiDHeadCnt'];
          var menus = []
          this.zaikoList = [];
          forEach(responseMenuList.menus, (item1) => {
              forEach(item1.plans, (item2) => {
                  var planPrm = {}
                  planPrm['menuNo'] = item1['menuNo'];
                  planPrm['planId'] = item2['planId'];
                  planPrm['roomId'] = item2['roomId'];
                  menus.push(planPrm);
              })
          })
          socketPrm['menus'] = menus;
          this.stompClient.send("/app/sendMessage", {}, JSON.stringify(socketPrm));
    },
    connect(responseMenuList) {
    if (this.stompClient !== null && this.stompClient.connected) {
      // 既にソケットがオープンしている場合は同じ動作を繰り返す
      this.subscribeToSocket(responseMenuList);
      // 60秒後にクローズする処理をセットしない
      return;
    }
    let socket = new SockJS(process.env.VUE_APP_AUTHORIZATION + '/data-info');
    this.stompClient = Stomp.over(socket);

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 8; // 生成するユーザー名の長さ

    let username = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        username += characters.charAt(randomIndex);
    }
    let headers = {
    // ユーザー名などの情報を追加
      username: username
    };

    this.stompClient.connect(headers, (frame) => {
        // console.log('Connected as ' + username);
        this.subscribeToSocket(responseMenuList);

         //一定時間経過後にソケットをクローズ
        setTimeout(() => {
            if (this.stompClient !== null) {
                this.stompClient.disconnect();
            }
        }, 60000); // 60秒後にクローズする例
        this.stompClient.subscribe("/info/values/"+username, (val) => {
            // console.log('recv');
            const jsonObject = JSON.parse(val.body);

            let found = false;
            for (let i = 0; i < this.zaikoList.length; i++) {
              const zaikoUnit = this.zaikoList[i];

              if (
                zaikoUnit['menuNo'] === jsonObject['menuNo'] &&
                zaikoUnit['planId'] === jsonObject['planId'] &&
                zaikoUnit['roomId'] === jsonObject['roomId']
              ) {
                found = true;
                break; // 一致したらループを抜ける
              }
            }
            if(!found) {
              this.zaikoList.push(jsonObject);
            }

          });
      });
    },
    /**
     * 国内宿泊施設の商品一覧を取得
     * @param {boolean} isLoading 
     */
    async getMenuList(isLoading = false) {
      this.plansBenepoReturnInfo = [];
      this.zaikoList = [];
      try {
        if (isLoading) {
          this.isLoadingOpensearch = true ;
        }
        if (this.isPublicStay) {
          await this.getMenuListPublicStay()
          this.isLoadingOpensearch = false ;
          return
        }

        // 240829時点未使用
        // this.checkInDateStock = this.filterForm.checkInDate

        // Get menu no
        const params = {
          page: this.pagination.page - 1,
          size: 10
        }
        const body = this.parseBodySearch()
        if (this.flagChange) {
          this.flagChange = !this.flagChange
        }
        this.updateFilterFormTags()
        const responseMenuList = await this.$repositories('search').searchMenu(
          body,
          params
        )

        if ('checkInDate' in body && body.checkInDate.length > 0) {
            responseMenuList['body'] = body;
            this.connect(responseMenuList);
        }

        this.yadosTotal = get(responseMenuList, 'totalItems', 0)
        this.totalItemsNative = this.yadosTotal

        this.mappingAggregation(get(responseMenuList, 'aggregation', {}))

        this.isLoadingOpensearch = false;


        this.menuListSearch = cloneDeep(responseMenuList.menus);
        // CRM独自対応
        // this.userCafeSubscriptionId = cloneDeep(responseMenuList.userCafeSubscriptionId);
        // this.userSubsidyList = cloneDeep(responseMenuList.userSubsidyId);

        // Get favourite by menu no
        if (this.$auth.loggedIn) {
          const favouriteProcesses = []
          forEach(responseMenuList.menus, (item) => {
            const process = this.$repositories('menu').getFavourite({
              menuNo: item.menuNo,
              serviceType: 'stay'
            })
            favouriteProcesses.push(process)
          })

          const responseFavouriteAll = await Promise.allSettled(favouriteProcesses)
          const responseFavourite = responseFavouriteAll
            .map((item) => item.value)
            .reduce((acc, menu) => {
              acc[menu.menuNo] = {
                id: menu.id,
                favourite: menu.favourite,
                quantity: menu.quantity
              }
              return acc
            }, {})

          /*  Important : This need to be perform only after getting Favourite info
              in order to show favourite icon correctly in search result list */
          this.menuListSearch = cloneDeep(responseMenuList.menus);

          forEach(this.menuListSearch, (value) => {
            value.favourite = responseFavourite[value.menuNo]
          })
        }

      } catch (e) {
        this.isLoadingOpensearch = false ;
      }
    },
    /**
     * 公共の宿の商品一覧を取得
     * @param {*} nativeCall 
     */
    async getMenuListPublicStay(nativeCall = false) {
      // Get menu no
      const params = {
        page: this.pagination.page - 1,
        size: 10
      }

      const body = this.isPublicStay
        ? this.parseBodySearchPublicStay()
        : this.parseBodySearch()
      this.updateFilterFormTags()

      const responseMenuList = await this.$repositories('search').searchMenuPublicStay(
        body,
        params
      )

      const totalItems = get(responseMenuList, 'totalItems', 0)
      this.totalItemsNative = totalItems

      if (nativeCall) return

      this.yadosTotal = totalItems

      if (totalItems === 0) {
        this.menuListSearch = []
        return
      }

      // const menuNos = uniq(responseMenuList.menus).join('-')

      /* MNAPI不使用のため削除（恒久対応で削除）------------------- */
      let menuNos = []
      const listMenu = []
      forEach(responseMenuList.menus, (item) => {
        if (item.menuNo !== null) {
          listMenu.push(item.menuNo)
        }
      })
      menuNos = uniq(listMenu).join('-')
      const responseMenuDetail = await this.$repositories('search').searchMenuList({
        menuNos
      })
      forEach(responseMenuDetail, (element) => {
        if (!element.menuImages) {
          element.menuImages = []
        }
        element.menuImages.map((item) => ({
          imageUrl: item.imageUrl,
          imageLabel: item.imageExplanation
        }))
        element.favourite = {}
      })
      this.menuListSearch = responseMenuDetail
      /* ----------------------------------------------------------- */

      // indexの値をそのまま使用する(恒久対応)
      // this.menuListSearch = responseMenuList.menu

      // Get favourite by menu no
      const favouriteProcesses = []
      forEach(listMenu, (item) => {
        const process = this.$repositories('menu').getFavourite({
          menuNo: item,
          serviceType: 'stay'
        })
        favouriteProcesses.push(process)
      })

      const responseFavouriteAll = await Promise.allSettled(favouriteProcesses)
      const responseFavourite = responseFavouriteAll
        .map((item) => item.value)
        .reduce((acc, menu) => {
          acc[menu.menuNo] = {
            id: menu.id,
            favourite: menu.favourite,
            quantity: menu.quantity
          }
          return acc
        }, {})

      forEach(this.menuListSearch, (value) => {
        value.favourite = responseFavourite[value.menuNo]
      })
    },
    /**
     * お気に入り操作
     * @param {*} favItem 
     */
    updateFavourite(favItem){
      this.menuListSearch.find(item => item.menuNo === favItem.menuNo).favourite = favItem.favourite
      this.menuListSearch = cloneDeep(this.menuListSearch)
    },
    /**
     * 選択されたこだわり条件のタブを表示
     * @param {*} keyValue 
     * @param {*} newValue 
     */
    updateFilterFormTags() {
      const data = []
      forEach(this.filterForm, (value, key) => {
        if (Array.isArray(value) && value.length && value[0]) {
          data.push({
            key,
            value
          })
        }
      })
      
      this.filterFormTags = data
    },
    /**
     * おそらくこだわり条件タブを削除
     * 240904時点未使用
     * @param {*} keyValue 
     * @param {*} newValue 
     */
    onRemoveTags(keyValue, newValue) {
      const newFilterForm = {}
      forEach(this.filterForm, (value, key) => {
        if (key === keyValue) {
          const data = value.filter((item) => item !== newValue)
          newFilterForm[key] = data
        } else {
          newFilterForm[key] = value
        }
      })

      this.filterForm = newFilterForm
      this.updateQueryRouter()
      this.getMenuList()
    },
    /**
     * 国内宿泊施設用のクエリパラメータを生成して実行？
     */
    updateQueryRouter() {
      if (this.isPublicStay) {
        this.updateQueryRouterPublicStay()
        return
      }

      const query = {}

      forEach(this.filterForm, (value, key) => {
        if (Array.isArray(value) && value.length) {
          query[key] = value.join(',')
        } else if (key === 'checkInDate') {
          query[key] = value ? moment(value).format('YYYY-MM-DD') : ''
        } else if (key !== 'checkOutDate') {
          query[key] = value
        }
      })
      query['page'] = this.pagination.page

      // top宿泊画面用の検索条件保持クッキー追加
      document.cookie = createSetCookie('cr_stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)

      this.$router.replace({ query }).catch(() => {})
    },
    /**
     * 公共の宿用のクエリパラメータを生成して実行？
     */
    updateQueryRouterPublicStay() {
      const dataIncludes = [
        'areaLrgClassCd',
        'areaMidClassCd',
        'areaSmlClassCd',
        'areaDtlClassCd',
        'keyword',
        'orderBy',
        'category'
      ]

      const query = {}
      forEach(this.filterForm, (value, key) => {
        if (dataIncludes.includes(key)) {
          query[key] = value || ''
        }
      })
      this.$router.replace({ query }).catch(() => {})
    },
    /**
     * 検索
     * @param {*} isLoading 
     * @param {*} type 
     */
    async onSearch(isLoading) {

      this.error.keywordError = ""

      // 国内宿泊
      if(!this.isPublicStay){
        if(!this.filterForm.keyword && (!this.filterForm.areaMidClassCd || !this.filterForm.areaSmlClassCd)){
          this.error.keywordError = !this.filterForm.areaMidClassCd && !this.filterForm.areaSmlClassCd
            ? "キーワードを入力するか都道府県・市区町村を選択してください。"
            : "キーワードを入力するか市区町村を選択してください。"
          return
        }
      }

      // 公共の宿
      if (this.isPublicStay) {
        if (!this.filterForm.keyword && !this.filterForm.areaMidClassCd) {
          this.error.keywordError = "キーワードを入力するか都道府県を選択してください。"
          return
        }
      }

      this.isSidebarVisible = false
      this.isShowPeopleFilter = false
      this.isShowSpecialConditionsModal = false
      this.pagination.page = 1

      this.updateQueryRouter()
      await this.getMenuList(isLoading)
      this.setQueryUrl()
    },
    /**
     * 画面上で設定したパラメータからURLを生成する
     */
    setQueryUrl() {
      const query = {}
      Object.keys(this.filterForm)
        .filter((key) => !this.excludeKeys.includes(key))
        .forEach((e) => {
          const obj = this.filterForm[e]
          if(obj){
            if (Array.isArray(obj) && obj.length > 0) {
              query[e] = obj.join(',')
            } else if (Object.getPrototypeOf(obj).constructor.name === 'Moment') {
              query[e] = obj.format('YYYY-MM-DD');
            } else {
              query[e] = obj
            }
          }
        })

      const toFullPath = this.$router.resolve({
        path: this.$route.path,
        params: this.$route.params,
        query
      })?.href || ''

      if (this.$route.fullPath !== toFullPath) {
        // top宿泊画面用の検索条件保持クッキー追加
        document.cookie = createSetCookie('cr_stay_search_conditions', encodeURIComponent(JSON.stringify(query)), undefined, true)
        this.$router.replace({
          path: this.$route.path,
          params: this.$route.params,
          query
        })
      }
      if(this.isPublicStay) {
        return;
      }
      // クッキーから取得したリストをオブジェクト化する
      const cookieStr = Cookies.get("CR_STAY_SEARCH_HISTORY_COOKIE_ID");
      // JSONを配列に変換
      let cookieSearchDataList = [];
      if (cookieStr) {
        try {
          cookieSearchDataList = JSON.parse(cookieStr);
        } catch (error) {
        }
      }
      //現在日時を取得
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 月は0始まりなので +1 する
      const day = String(now.getDate()).padStart(2, "0");
      const searchDate = `${year}/${month}/${day}`;
      // 現在の日付から30日前の日付を計算
      const pastDate = new Date();
      pastDate.setDate(now.getDate() - 30);

      //検索履歴は３個までなので前から２つになるまで消す。
      if (cookieSearchDataList.length > 2) {
        cookieSearchDataList.splice(0, cookieSearchDataList.length - 2);
      }
      //alert(cookieSearchDataList.length);
      //検索履歴は30日前まで消す。
      for (let i = cookieSearchDataList.length - 1; i + 1 > 0; i--) {
        //alert(JSON.stringify(cookieSearchDataList[i]));
        const inputDate = new Date(cookieSearchDataList[i]["searchDate"]);
        if (inputDate < pastDate) {
          cookieSearchDataList.splice(i, 1);
        }
      }

      let urlDispConditions = [];
      if (query["checkInDate"]) {
        urlDispConditions.push(query["checkInDate"]);
      } else {
        urlDispConditions.push("日付未指定");
      }
      urlDispConditions.push(query["stayNights"] + "泊");
      urlDispConditions.push(query["roomCnt"] + "部屋");
      urlDispConditions.push("大人" + query["adultHeadCnt"] + "人");
      const tmpQuery = this.$route.query;
      
      const exLowerGradesHeadCntTmp = tmpQuery.exLowerGradesHeadCnt || 0;
      const exUpperGradesHeadCntTmp = tmpQuery.exUpperGradesHeadCnt || 0;
      const youjiAHeadCntTmp = tmpQuery.youjiAHeadCnt || 0;
      const youjiBHeadCntTmp = tmpQuery.youjiBHeadCnt || 0;
      const youjiCHeadCntTmp = tmpQuery.youjiCHeadCnt || 0;
      const youjiDHeadCntTmp = tmpQuery.youjiDHeadCnt || 0;

      const childNum =
        Number(exUpperGradesHeadCntTmp)
        + Number(exLowerGradesHeadCntTmp)
        + Number(youjiAHeadCntTmp)
        + Number(youjiBHeadCntTmp)
        + Number(youjiCHeadCntTmp)
        + Number(youjiDHeadCntTmp);


      if (childNum > 0) {
        urlDispConditions.push(
          "子供" + childNum + "人",
        );
      }
      if (this.searchDest != null && "for_search_history" in this.searchDest && this.searchDest.for_search_history.length > 0) {
		  let cityLabel = "";
		  let sp = "";
		  //半角SP区切りにして表示ラベルを編集
		  for (const item of this.searchDest.for_search_history) {
			const parts = item.split("/");
			cityLabel += sp + parts[parts.length - 1];
			sp = " ";
          }
          //alert(cityLabel);
          urlDispConditions.push(cityLabel);
      }
      if (tmpQuery.keyword) {
        urlDispConditions.push(tmpQuery.keyword);
      }

      const cookieSearchData = {
        searchDate: searchDate,
        urlLink: process.env.VUE_APP_BASE_URL + toFullPath,
        urlDisp: this.cutStringByLength(urlDispConditions.join(" "),100),
      };
      // 新しい要素をリストに追加
      cookieSearchDataList.push(cookieSearchData);
      Cookies.set("CR_STAY_SEARCH_HISTORY_COOKIE_ID", JSON.stringify(cookieSearchDataList), {
        expires: 30,
        domain: process.env.VUE_APP_COOKIE_DOMAIN,
      });
    },
    /**
     * ページング操作
     * @param {*} e 
     */
    async paging(e) {
      this.pagination.page = e
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.updateQueryRouter()
      await this.getMenuList(true)
    },
    /**
     * 国内宿泊施設用のリクエスト用のbodyパラメータを整形
     */
    parseBodySearch() {
      const body = {
          //検索文字列の前後の空白を全て削除し、中間の空白を半角スペース1文字に変換
        keyword: this.filterForm.keyword.replace(/\s+/g, " ").trim(),
        roomCnt: this.filterForm?.roomCnt || 1
      }
      body.adultHeadCnt = Number(this.filterForm.adultHeadCnt) || 0
      body.exUpperGradesHeadCnt = Number(this.filterForm.exUpperGradesHeadCnt) || 0
      body.exLowerGradesHeadCnt = Number(this.filterForm.exLowerGradesHeadCnt) || 0
      body.youjiAHeadCnt = Number(this.filterForm.youjiAHeadCnt) || 0
      body.youjiBHeadCnt = Number(this.filterForm.youjiBHeadCnt) || 0
      body.youjiCHeadCnt = Number(this.filterForm.youjiCHeadCnt) || 0
      body.youjiDHeadCnt = Number(this.filterForm.youjiDHeadCnt) || 0
      if (this.filterForm.numPeople) body.numPeople = Number(this.filterForm.numPeople)
      if (this.filterForm.feeLower) body.feeLower = this.filterForm.feeLower
      if (body.feeLower == 0) {
        body.feeLower = 1
      }
      if (this.filterForm.feeUpper) body.feeUpper = this.filterForm.feeUpper
      if (body.feeUpper == 0) {
        body.feeUpper = 100000000; // #72331 で 100 万 → 1 億に変更。本来は上限を外したい意向だったが修正影響があるため上限引き上げの方針になった。
      }
      if (this.flagChange) {
        body.areaLrgClassCd = ''
        body.areaMidClassCd = ''
        body.areaSmlClassCd = ''
        body.areaDtlClassCd = ''
      } else {
        if (this.filterForm.areaLrgClassCd)
          body.areaLrgClassCd = this.filterForm.areaLrgClassCd
        if (this.filterForm.areaMidClassCd)
          body.areaMidClassCd = this.filterForm.areaMidClassCd
        if (this.filterForm.areaSmlClassCd) {
          // 市区町村が文字列（例："tokyo,nishi" or "tokyo" 等）だった場合
          if (typeof this.filterForm.areaSmlClassCd === 'string') {
            // 市区町村文字列を配列にする
            body.areaSmlClassCd = this.filterForm.areaSmlClassCd.includes(',')
              ? this.filterForm.areaSmlClassCd.split(',')
              : [this.filterForm.areaSmlClassCd]
          } else {
            body.areaSmlClassCd = this.filterForm.areaSmlClassCd
          }
        }
        if (this.filterForm.areaDtlClassCd) {
          // エリアが文字列（例："A,B" or "D" 等）だった場合
          if (typeof this.filterForm.areaDtlClassCd === 'string') {
            // エリア文字列を配列にする
            body.areaDtlClassCd = this.filterForm.areaDtlClassCd.includes(',')
              ? this.filterForm.areaDtlClassCd.split(',')
              : [this.filterForm.areaDtlClassCd]
          } else {
            body.areaDtlClassCd = this.filterForm.areaDtlClassCd
          }
        }
      }
      if (this.filterForm.orderBy === '安い順') {
        this.filterForm.orderBy = 'LOWEST_PRICE'
      }
      if (this.filterForm.orderBy === 'おすすめ順') {
        this.filterForm.orderBy = 'PROPOSE'
      }
      if (this.filterForm.orderBy) body.searchSortBox = this.filterForm.orderBy
      // #47838_4 泊数の追加
      body.stayNights = this.filterForm.stayNights || 1;
      // Check in & check out
      if (this.filterForm.checkInDate) {
        const checkInDate = moment(this.filterForm.checkInDate).format('YYYY-MM-DD')
        const checkOutDate = moment(this.filterForm.checkInDate)
          .clone()
          .add(this.filterForm.stayNights, 'days')
          .format('YYYY-MM-DD')
        body.checkInDate = checkInDate
        body.checkOutDate = checkOutDate
      // } else {
      //   const checkInDate = moment().format('YYYY-MM-DD')
      //   const checkOutDate = moment(checkInDate)
      //     .clone()
      //     .endOf('month')
      //     .format('YYYY-MM-DD')
      //   body.checkInDate = checkInDate
      //   body.checkOutDate = checkOutDate
      }

      // facility
      const facility = this.filterForm.facility
      if (facility && facility.length) {
        for (const item of facility) {
          body[item] = true
        }
      }

      // roomType
      const roomType = cloneDeep(this.filterForm.roomType)
      if (roomType && roomType.length) {
        body['cdSearchRoomType'] = mappingKeyRoomType(roomType)
      }

      // mealCondition
      const mealCondition = this.filterForm.mealCondition
      if (mealCondition && mealCondition.length) {
        for (const item of mealCondition) {
          body[item] = true
        }
      }

      // roomCondition
      const roomCondition = this.filterForm.roomCondition
      if (roomCondition && roomCondition.length) {
        for (const item of roomCondition) {
          body[item] = true
        }
      }

      // serviceEquip
      const serviceEquip = this.filterForm.serviceEquip
      if (serviceEquip && serviceEquip.length) {
        for (const item of serviceEquip) {
          body[item] = true
        }
      }

      // usageMethod
      const usageMethod = this.filterForm.usageMethod
      if (usageMethod && usageMethod.length) {
        for (const item of usageMethod) {
          if(item === "useAutoPayment"){
            body["canUseBenepoint"] = true
          }else {
            body[item] = true
          }
        }
      }

      // planByCompany
      const planByCompany = this.filterForm.planByCompany
      if (planByCompany && planByCompany.length) {
        for (const item of planByCompany) {
          body[item] = true
        }
      }

      return body
    },
    /**
     * 公共の宿用のリクエスト用のbodyパラメータを整形
     */
    parseBodySearchPublicStay() {
      const body = {
          //検索文字列の前後の空白を全て削除し、中間の空白を半角スペース1文字に変換
        keyword: this.filterForm.keyword.replace(/\s+/g, " ").trim(),
      }

      if (this.filterForm.areaLrgClassCd)
        body.areaLrgClassCd = this.filterForm.areaLrgClassCd
      if (this.filterForm.areaMidClassCd)
        body.areaMidClassCd = this.filterForm.areaMidClassCd
      if (this.filterForm.areaSmlClassCd)
        body.areaSmlClassCd = this.filterForm.areaSmlClassCd
      if (this.filterForm.areaDtlClassCd)
        body.areaDtlClassCd = this.filterForm.areaDtlClassCd

      if (!this.filterForm.areaMidClassCd) delete body.areaLrgClassCd
      delete body.areaSmlClassCd
      delete body.areaDtlClassCd

      return body
    },
    /**
     * マッピング？現段階で不明
     * @param {*} data 
     */
    mappingAggregation(data) {
      forEach(this.filterFormOptions, (value) => {
        forEach(value, (item) => {
          if (item.searchParam === 'roomType') {
            if (isEmpty(item?.keys)) {
              item.total = this.formatCurrency(data[item.key], '') || 0
            } else {
              const arr = item.keys.map((a) => +this.formatCurrency(data[a], '') || 0)
              item.total = arr.reduce((a, b) => a + b)
            }
          } else if(item.searchParam === 'usageMethod' && item.value ==="useAutoPayment" ){
            item.total = this.formatCurrency(data["canUseBenepoint"], '') || 0
          } else {
            item.total = this.formatCurrency(data[item.value], '') || 0
          }
        })
      })
    },
    // 240829時点未使用
    // onChangeCategory(category) {
    //   this.filterForm.category = category.value
    //   this.onSearchNative()
    // },
    // 240829時点未使用
    // handleSearchCategory() {
    //   this.isShowCategoryPopup = false
    //   this.onSearch()
    // },
    // 240829時点未使用
    // onLoadAreaData(areaData) {
    //   this.areaData = areaData
    // },
    // 240829時点未使用
    // DP検索カテゴリに関するURL生成
    // redirectUrl(midCategory,smlCategory) {
    //   return this.updateQueryRouter(midCategory,smlCategory)
    // },
    // 240829時点未使用
    // updateQueryRouter(midCategory,smlCategory) {
    //   const query = {}

    //   const keyword = this.$route.query["keyword"] || '';
    //   if (keyword) {
    //     query.keyword = keyword;
    //   }

    //   if(midCategory === "201" || midCategory === "204") {
    //     query.type = "4";
    //   } else {
    //     // 中カテゴリ「パッケージツアー・旅行代理店」「航空券・交通」「その他旅行関連」はtype=3
    //     query.type = "3";
    //   }
    //   query.catLrgClassCd = "101";
    //   query.catMidClassCd = midCategory;
    //   if(smlCategory) {
    //     query.catSmlClassCd = smlCategory
    //   }
    //   const params = new URLSearchParams(query);
    //   const url = process.env.VUE_APP_LIFE_DOMEIN + '/menus/tour?' + params;
    //   return url;
    // },
    // 240829時点未使用
    // アコーディオン処理
    // isOpen(catClassCd) {
    //   let middles = this.midCategoryList;
    //   let smalls = this.smlCategoryList;
    //   middles.forEach((mid) => {
    //     // 中カテ：パッケージツアー・旅行代理店、航空券・交通の小カテ表示制御
    //     if (mid.catClassCd === catClassCd) {
    //       if (mid.flag) {
    //         mid.flag = false;
    //       } else {
    //         mid.flag = true;
    //       }
    //     }
    //   })
    //   smalls.forEach((sml) => {
    //     // 中カテ：パッケージツアー・旅行代理店、航空券・交通の小カテ表示制御
    //     if (sml.catMidClassCd === catClassCd) {
    //       if (sml.flag) {
    //         sml.flag = false;
    //       } else {
    //         sml.flag = true;
    //       }
    //     }
    //   });
    // },
  },
}
</script>

<style scoped lang="scss">
@import './style.scss';
@import '@/assets/css/_foundation/_variable-colors.scss';

@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.stay-search-menu {
  background-color: $white;
  margin-top: 1.5rem;
  width: 100%;

  @include sp {
    margin-top: 0;
  }

  &__inner {
    display: flex;
    margin: 0 auto;
    width: 1032px;

    @include sp {
      padding: 0 1rem;
      width: 100%;
    }
  }

  &__sidebar {
    margin-right: 2rem;
    width: 15rem;

    @include sp {
      display: none;
    }

    &.--sp {
      border: 2px solid $cool-gray-4;
      border-radius: .5rem;
      display: none;
      width: 100%;

      @include sp {
        display: block;
      }
    }

    &__inner {
      display: grid; 
      grid-template-rows: 0fr;
      transition: .2s grid-template-rows ease-in-out;

      &.is-visible {
        grid-template-rows: 1fr;
      }

      > div {
        overflow: hidden;
      }
    }
  }

  &__body {
    width: calc(100% - 17rem);

    @include sp {
      width: 100%;
    }
  }

  &__button {
    &.--toggle {
      background-color: $white;
      border-radius: 0 0 .55rem .5rem;
      border-top: 1px solid $cool-gray-4;
      color: $black;
      display: block;
      font-family: inherit;
      font-weight: bold;
      padding: .5rem 1rem;
      position: relative;
      width: 100%;

      @include hover {
        span {
          opacity: .5;
        }
      }
    }
  }

  // ページネーション、アイコン説明へのリンク、ソート
  &__options {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    padding: 1rem 0 0;

    @include sp {
      align-items: flex-end;
      justify-content: space-between;
    }
  }

  // ページネーション
  &__pagination {
    align-items: center;
    display: flex;

    &__label {
      margin-right: 1rem;
      
      > .is-strong { font-weight: bold; }
    }

    &__pager {
      @include sp { display: none; }
    }
  }

  // 各種アイコンについて
  &__icon-guide {
    margin-bottom: .5rem;
    text-align: right;
    width: 100%;

    &__link {
      align-items: center;
      color: $cool-gray;
      display: inline-flex;
      margin-left: auto;
      transition: none;

      @include hover {
        opacity: .5;
      }

      @include sp {
        display: inline-flex;
        font-size: .75rem;
      }
    }

    &__image {
      display: block;
      height: 1rem;
      margin-right: .25rem;
      width: 1rem;

      @include sp {
        height: .875rem;
        width: .875rem;
      }
    }
  }

  // ソート
  &__sort {
    border: 1px solid $cool-gray-3;
    border-radius: .25rem;
    height: 2rem;
    margin-left: auto;
    width: 8rem;
  }
}

.content {
  display: flex;
  align-items: center;
  width: 100%;
  &_input {
    padding: 6px 14px;
    border-top: 1px solid #CACCCF;
    border-bottom: 1px solid #CACCCF;
    border-left: 1px solid #CACCCF;
    border-right: none;
    border-radius: 8px 0 0 8px;
    width: 100%;
    color: #1F2021;
    transition: none;
    height: auto;
    &:focus {
      padding: 5px 15px;
      outline: 2px solid #E60021;
      background-color: #FFF7F7;
      border: none;
    }
  }
  &_button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 7px 0px;
    border-radius: 0 8px 8px 0;
    background-color: #1F2021;
    color: white;
    transition: none;
    width: 67px;
    height: auto;
    border: none;
    &:hover {
      opacity: .8;
      border: none;
      .content_button_icon {
        fill: white;
      }
    }
    &_icon {
      font-size: 20px;
      width: 24px;
      height: 24px;
    }
    &_text {
      white-space: nowrap;
    }
  }
}

@media only screen and (max-width: 639px) {
  .text-sp-base {
    font-size: 13px !important;
  }

  .content {
    &_input {
      width: calc(100% - 4rem);
      height: 2.5rem;
      padding: 6px 10px;
      border-radius: 3px 0 0 3px;
      &:focus {
        padding: 7px 11px;
      }
    }
    &_button {
      width: 4rem;
      height: 2.5rem;
      padding: 10px 1rem;
      border-radius: 0 3px 3px 0;
      background-color: #E60021;
      width: auto;
      &_icon {
        font-size: 20px;
        width: 13px;
        height: 13px;
        margin-right: 4px;
      }
      &_text {
        font-size: 0.875rem;
        letter-spacing: 0;
        white-space: nowrap;
      }
    }
  }
}
.menu-tags__right {
    a {
      color: #73767A;
      font-size: 0.9375rem;
    }
  }

  .level2 {
  .level2-url {
    color: #0c0c0c;
    padding-left: 2.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-right: 1.5rem;
  }
}
.l-side-tour {
  width: 100%;
  font-size: 0.875rem;
  // @include mq() {
  //   width: auto;
  // }
  &__wrap {
    // padding: 0.5rem 1rem;
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    background-color: #fff;
    border-radius: .5rem;
    // box-shadow: 0 1px .5rem rgba($color: $CoolBlack, $alpha: .08);
    overflow: hidden;
    // @include mq() {
    //   overflow: unset;
    // }
  }
  &__lists {
    position: relative;
    ul {
      &:not(:last-child) {
        margin-bottom: .625rem;
        padding-bottom: .625rem;
        // border-bottom: 1px solid $CoolGray4;
        // @include mq() {
        //   margin-bottom: 1.75rem;
        //   padding-bottom: 0;
        // }
      }
    }
  }
  &__list {
    &.accordion {
      position: relative;
      .accordion__button {
        padding-right: 40px;
        font-size: 0.75rem;
        border: none;
        background-color: #ffffff00;
        width: 0.5rem;
        height: 2rem;
        position: absolute;
        right: 0;
        top: 0.2rem;
        z-index: 2;
      }
      .accordion__angle {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        // right: 10px;
        width: 0.7rem;
        height: 0.7rem;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 200ms;
        &.rotate-0 {
          transform: rotate(0deg);
        }
        &.rotate-180 {
          transform: rotate(180deg)
        }
      }
    }
    &__item {
      position: relative;
      display: block;
      // color: $CoolBlack;
      color: #0c0c0c;
      // padding: 0.5rem 1.5rem;
      .c-icon {
        position: absolute;
        top: 50%;
        right: 13px;
        transform: translateY(-50%);
      }
      &--head {
        font-weight: 700;
      }
      &--checked {
        position: absolute;
        top: 50%;
        right: 13px;
        transform: translateY(-50%);
        // color: $CoolGray1;
      }
      &--checkedMid {
        position: absolute;
        top: 50%;
        right: 30px;
        transform: translateY(-50%);
        // color: $CoolGray1;
      }
      // @include mq() {
      //   padding-top: .625rem;
      //   padding-bottom: .625rem;
      // }
      // input:checked + .c-checkbox__box::before {
      //   // color: $Red;
      // }
      &.level {
        &.level-url {
          color: #0c0c0c;
          padding: 0.5rem 1.5rem;
        }
      }
      &.level2 {
        & .level2-url {
          color: #0c0c0c;
          padding-left: 2.5rem;
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
          padding-right: 1.5rem;
        }
      }
      &.level3 {
        padding-left: 3.5rem;
      }
    }
    &__bottom {
      border-bottom: none;
  }
  a {
    // color: $CoolBlack;
    color: #0c0c0c;
    // .c-icon {
    //   width: 1.25em;
    //   height: 1.25rem;
    //   // g {
    //   //   // fill: $CoolGray;
    //   // }
    // }
    // &:hover {
    //   // color: $Red;
    //   text-decoration: none;
    //   .c-icon {
    //     g {
    //       // fill: $Red;
    //     }
    //   }
    // }
  }
  .l-side__submit {
    text-align: center;
    .l-side__submit__button {
      width: 120px;
      padding: 0.25rem 1rem;
      // background-color: $CoolBlack;
      border-radius: 8px;
      cursor: pointer;
      @include mq() {
        background-color: #1f2021;
        padding: 1rem;
        width: 200px;
        border-radius: 8px;
      }
      .l-side__submit__label {
        color: #fff;
        font-size: 0.9rem;
      }
    }
  }
  }
}
.content_button_icon__white g {
  fill: white !important;
}

.wrap {
  margin-bottom: 20px;
  position: relative;
  h1 {
    font-size: 20px;
  }
  &_sp {
    @screen sm {
      margin-top: 0;
      font-size: 18px !important;
      font-feature-settings: "palt";
    }
  }
}

/* BSFRONT_INSOURCING-26 ここから */
// TODO: 2024/7/10納品優先でベタ書き -> コンポーネントに切り出すこと
.search-refine {
  &__form {
    border-bottom: none;

    &-button {
      background-color: $black;
      color: $white;
    }

    &.is-opened {
      border-bottom: 1px solid #e5e7eb;
      border-radius: .25rem;
    }
  }
  
  &__button {
    &--search {
      background-color: #1f2021;
      border-radius: 0 .25rem .25rem 0;
      color: #fff;
      cursor: pointer;
      display: block;
      height: 40px;
      width: 4rem;
    }
  }

  &__result {
    border-bottom: none;
    padding: .5rem 0;

    &-text {
      padding-left: 4px;
    }
  }

  &-menu-button {
    display: flex;
    justify-content: center;
    align-items: center;
    // TODO: コピペで持ってきたのでどこかで定義
    border: 1px solid rgba(229, 231, 235, var(--tw-border-opacity));
    border-radius: 0 0 4px 4px;
    color: $black;

    .icon {
      margin-left: 4px;
    }

    &.--open {
      .icon {
        transform: rotate(90deg);
      }
    }

    &.--close {
      .icon {
        transform: rotate(-90deg);
      }
    }
  }

  &-animation-enter-active {
    &.is-opened {
      animation: search-refine-animation-open 0.05s;
      transform-origin: left top;
    }
  }

  @keyframes search-refine-animation-open {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(100%);
    }
  }
}

// TODO: 2024/7/10納品優先でベタ書き -> コンポーネントに切り出すこと
.search-condition {
  &-button {
    justify-content: center;
    border: none;
    border-radius: 16px;
    background-color: $cool-gray-4;
    width: 7.25rem;
    padding: 0;
    font-size: 0.75rem;
    font-weight: bold;
    color: $CoolBlack;
    &:hover {
      color: rgba(31, 32, 33, 0.65);
    }
  }
  &-text {
    display: block; // NOTE: 念の為
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    flex: 1;
    overflow: hidden;
    max-height: 3em; // NOTE: 念の為
    font-size: 12px;
    margin-left: 0.75rem;
  }
}
/* BSFRONT_INSOURCING-26 ここまで */

// TODO: 
.searchContent {
  padding: 0 1rem;
  &__detail {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-top: 1.5rem;
  }
  &__dateSelector {
    display: inline-flex;
    align-items: center;
    row-gap: 0.5rem;
    flex-wrap: wrap;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
  &__stayRoom {
    display: flex;
    align-items: center;
    row-gap: 0.5rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
  &__stayNumber {
    margin-bottom: 1rem;
  }
  &__stayCharge {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-right: 1rem;
    margin-bottom: 1rem;
    .searchContent__title {
      margin-right: 9px;
    }
  }
  &__stayConditions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 1rem;
  }
  &__title {
    margin-right: 1rem;
  }
  &__input {
    position: relative;
    svg {
      position: absolute;
      right: 0.8rem;
      top: 0;
      bottom: 0;
      margin: auto;
      z-index: 1;
    }
    input[type="text"] {
      &:focus {
        outline: 2px solid $black;
        outline-offset: -2px;
      }
    }
  }
  &__datePicker::v-deep {
    position: relative;
    font-size: 1rem;
    .vdp-datepicker__clear-button {
      top: 22%;
      left: 10px;
      font-size: 20px;
    }
    input[type="text"] {
      background: transparent;
      border-top: 1px solid $CoolGray3;
      border-bottom: 1px solid $CoolGray3;
      border-left: 1px solid $CoolGray3;
      border-radius: 0.25rem 0 0 0.25rem;
      padding: 0.375rem 2.4rem 0.375rem 0.5rem;
      width: 211px;
      height: 2.5rem;
      cursor: pointer;
      text-align: right;
      &::placeholder {
        text-align: left;
        color: $CoolGray3;
      }
      &:focus {
        outline: 2px solid $black;
        outline-offset: -2px;
      }
    }
  }
  &__select {
    display: flex;
    position: relative;
    align-items: center;
    select {
      background: #fff;
      border: 1px solid $CoolGray3;
      border-radius: 0.25rem;
      padding: 0.375rem 0.5rem;
      width: 105px;
      height: 2.5rem;
      cursor: pointer;
      text-align: left;
      &::placeholder {
        text-align: left;
        color: $CoolGray3;
      }
    }
    &--night {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0.5rem;
        background: $CoolGray3;
        width: 1px;
        height: 1.5rem;
      }
      select {
        background: #fff;
        border-top: 1px solid $CoolGray3;
        border-right: 1px solid $CoolGray3;
        border-bottom: 1px solid $CoolGray3;
        border-left: none;
        border-radius: 0 0.25rem 0.25rem 0;
        padding: 0.375rem 0.5rem;
        width: 63px;
      }
    }
    &--adult {
      position: relative;
      width: 100%;
      span {
        position: absolute;
        left: 0.5rem;
        pointer-events: none;
        line-height: 2.5rem;
        z-index: 1;
      }
      ::v-deep {
        .ant-select-selection {
          height: 2.5rem;
          border-right: none;
          border-radius: 3px 0 0 3px;

          .ant-select-selection__rendered {
            overflow: hidden;
            height: 2.5rem;

            .ant-select-selection-selected-value {
              float: none;
              height: 2.5rem;
              line-height: 2.5rem;
              text-align: right;
            }
          }
        }
      }
    }
    &--child {
      position: relative;
      width: 100%;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0.5rem;
        background: $CoolGray3;
        width: 1px;
        height: 1.5rem;
      }
      span {
        position: absolute;
        left: 0.5rem;
        pointer-events: none;
        line-height: 2.5rem;
      }
      input[type="text"] {
        background: #fff;
        border-top: 1px solid $CoolGray3;
        border-right: 1px solid $CoolGray3;
        border-bottom: 1px solid $CoolGray3;
        border-left: none;
        border-radius: 0 0.25rem 0.25rem 0;
        padding: 0.375rem 0.5rem 0.375rem 3.5rem;
        width: 100%;
        height: 2.5rem;
        text-align: right;
      }
    }
    &--min {
      margin-right: 0.5rem;
      select {
        width: 152px;
      }
    }
    &--max {
      margin-left: 0.5rem;
      select {
        width: 152px;
      }
    }
  }
  &__button {
    display: flex;
    gap: 0 1.5rem;
    justify-content: center;
    margin-top: 0.5rem;
    border-top: 1px solid #CACCCF;
    padding-top: 1.5rem;
  }
}

@media only screen and (max-width: 639px) {
  ::v-deep .search-refine {
    &__form {
      padding-bottom: 1rem;
    }
    &__keyword {
      font-size: 0.75rem;
      margin-bottom: 0.5rem;
    }
    &__result {
      padding: 1rem;
      &-text {
        padding-left: 0.75rem;
      }
    }
  }
  ::v-deep .select-destination {
    &__text {
      font-size: 0.75rem;
    }
  }
  // 国内宿泊施設
  .searchContent {
    padding: 0;
    &__detail {
      width: 100%;
      padding-top: 0;
    }
    &__dateSelector {
      display: flex;
      width: calc(100% - (92px + 0.5rem));
      margin-right: 0.5rem;
      margin-bottom: 0;
    }
    &__stayRoom {
      flex-wrap: wrap;
      width: 92px;
      margin-right: 0;
      margin-bottom: 0;
    }
    &__stayNumber {
      flex-wrap: wrap;
      margin-bottom: 1rem;
      .searchContent__title {
        margin-bottom: 0.5rem;
      }
    }
    &__stayCharge {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-right: 0;
      margin-bottom: 1rem;
      .searchContent__title {
        margin-bottom: 0.5rem;
      }
    }
    &__title {
      width: 100%;
      margin-right: 0;
      font-size: 0.75rem;
    }
    &__input {
      width: 68%;
      svg {
        right: 0.5rem;
      }
    }
    &__datePicker::v-deep {
      width: 100%;
      .vdp-datepicker__clear-button {
        position: absolute;
        top: 14px;
        left: 9px;
        font-size: 12px;
        line-height: 13px;
      }
      input[type="text"] {
        width: 100%;
        font-size: 12px;
        text-align: left;
        padding: 0.375rem 0 0.375rem 1.5rem;
      }
    }
    &__select {
      width: 92px;
      &::after {
        content: none;
      }
      &::v-deep .ant-select-selection {
        box-shadow: none;
        &:hover {
          border-color: $CoolGray3;
        }
        &--single {
          overflow: hidden;
          width: 100%;
          height: 40px;
          .ant-select-selection__rendered {
            line-height: 40px;
            color: #1f2021;
          }
        }
        &-selected-value {
          float: none;
        }
      }
      &::v-deep .ant-select-open .ant-select-selection {
        outline: 2px solid $CoolBlack;
        outline-offset: -2px;
      }
      select {
        width: 100%;
        padding: 0.375rem 0.5rem;
        font-size: 14px;
        &::placeholder {
          text-align: left;
          color: $CoolGray3;
        }
      }
      &--night {
        position: relative;
        width: 32%;
        &::before {
          content: "";
          position: absolute;
          z-index: 1;
          left: 0;
          top: 0.5rem;
          background: $CoolGray3;
          width: 1px;
          height: 1.5rem;
        }
        &::v-deep .ant-select-selection--single {
          border-top: 1px solid #cacccf;
          border-right: 1px solid #cacccf;
          border-bottom: 1px solid #cacccf;
          border-left: none;
          border-radius: 0 0.25rem 0.25rem 0;
        }
        &::v-deep.ant-select-open .ant-select-selection--single {
          outline: 2px solid $CoolBlack;
          outline-offset: -2px;
        }
      }
      &--adult {
        width: 50%;
        span {
          top: 1px;
          font-size: 14px;
        }
        &::v-deep .ant-select-selection--single {
          padding: 0 0.5rem 0 3.625rem;
          .ant-select-selection__rendered {
            margin: 0;
            .ant-select-selection-selected-value {
              text-align: left;
            }
          }
        }
      }
      &--child {
        position: relative;
        width: 50%;
        span {
          top: 1px;
          font-size: 14px;
        }
        input[type=text] {
          width: 100%;
          padding: 0.5rem 0.5rem 0.5rem 3.625rem;
          font-size: 14px;
          text-align: left;
        }
        &::v-deep {
          .ant-select-arrow:hover g {
            fill: #cacccf;
          }
          .v-popper--theme-dropdown {
            width: 100%;
            .ant-select-arrow {
              transform: rotate(0deg);
              transition: transform 0.3s, -webkit-transform 0.3s;
            }
          }
          .v-popper--shown {
            input[type=text] {
              outline: 2px solid $CoolBlack;
              outline-offset: -2px;
            }
            .ant-select-arrow {
              transform: rotate(180deg);
            }
          }
        }
      }
      &--min {
        width: calc((100% - 2.5rem) / 2);
        margin-right: 0.75rem;
        select {
          width: 100%;
        }
      }
      &--max {
        width: calc((100% - 2.5rem) / 2);
        margin-left: 0.75rem;
        select {
          width: 100%;
        }
      }
    }
    .stay-search-datepicker::v-deep {
      .vdp-datepicker__clear-button {
        position: absolute;
        top: 22%;
        left: 10px;
        font-size: 20px;
      }
    }
  }
}
</style>
